import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MuiAlert from "@mui/material/Alert";
import type { AlertProps as MuiAlertProps } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import { TestProps } from "shared/types";

export type AllowedAlertVariants = Extract<
  MuiAlertProps["variant"],
  "standard"
>;

interface Props extends MuiAlertProps, TestProps {
  variant?: AllowedAlertVariants;
  title?: string;
}

const Alert = ({ testId, children, title, ...props }: Props) => (
  <MuiAlert
    data-testid={testId}
    {...props}
    iconMapping={{
      success: <CheckCircleOutlinedIcon fontSize="inherit" />,
      error: <ErrorOutlineOutlinedIcon fontSize="inherit" />,
      warning: <WarningAmberIcon fontSize="inherit" />,
      info: <InfoOutlinedIcon fontSize="inherit" />,
    }}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </MuiAlert>
);

export default Alert;
